import { ErpCountryWithPriceTypeResponse, PaginatedItemsResponse } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export function getErpCountries() {
	const fetchData = async () => {
		const data = await apiClientMutator<PaginatedItemsResponse<ErpCountryWithPriceTypeResponse>>({
			url: '/erp/countries',
			method: 'get',
		});
		return data;
	};
	return fetchData();
}
